<script setup lang="ts">
const { t } = useI18n();
const faqEntries = computed(() => [{
  title: t('agent.faq.question_1'),
  content: t('agent.faq.answer_1'),
}, {
  title: t('agent.faq.question_2'),
  content: t('agent.faq.answer_2'),
}, {
  title: t('agent.faq.question_3'),
  content: t('agent.faq.answer_3'),
}, {
  title: t('agent.faq.question_4'),
  content: t('agent.faq.answer_4'),
}, {
  title: t('agent.faq.question_5'),
  content: t('agent.faq.answer_5'),
}]);
</script>

<template>
  <IadWrapper>
    <IadTitle
      class="pb-xs"
      variant="large"
      tag="p"
      :text="$t('core.common.faq.title')"
    />
    <div class="lg:w-1/2">
      <IadAccordion
        v-for="{ title, content } of faqEntries"
        :key="title"
        name="faq-agents"
        title-tag="h2"
        :title
        :content
      />
    </div>
  </IadWrapper>
</template>
